export default "__VITE_ASSET__c5dec2ef__"